import { Action, createReducer, on } from '@ngrx/store';
import {
    getPaymentLink, getPaymentLinkSuccess, getPaymentLinkFailure,
    getAllPaymentlinksListExport,
    getAllPaymentLinkSuccess,
    getAllPaymentLinkFailure,
    resetPaymentlinksDetailsState,
   
} from './paymentlinks.action';


export interface paymentLinkState {
    getpaymentLinkResponse: any,
  
    getallpaymentlinkExportResponse: any,
}


export const initialState: paymentLinkState = {
    getpaymentLinkResponse: null,
    getallpaymentlinkExportResponse: null,
   

}

export const PaymentLinksreducer = createReducer(
    initialState,
    on(getPaymentLink, state => ({ ...state })),
    on(getPaymentLinkSuccess, (state, { getpaymentLinkResponse }) => ({ ...state, getpaymentLinkResponse })),
    on(getPaymentLinkFailure, (state, { getpaymentlinkError }) => ({ ...state, getpaymentlinkError })),


    on(getAllPaymentlinksListExport, state => ({ ...state })),
    on(getAllPaymentLinkSuccess, (state, { getallpaymentlinkExportResponse }) => ({ ...state, getallpaymentlinkExportResponse })),
    on(getAllPaymentLinkFailure, (state, { getallpaymentlinkExportError }) => ({ ...state, getallpaymentlinkExportError })),



     on(resetPaymentlinksDetailsState, (state) => ({
        ...state,
        getpaymentLinkResponse: null,
        getallpaymentlinkExportResponse: null, // Resetting this specific property
      })),
    





);

